import { flatten, flow, map, values } from 'lodash/fp';

window.googletag = window.googletag || {};
window.googletag.cmd = window.googletag.cmd || [];

const getAllSlots = flow(values, map(values), flatten);

function createDoubleClick(config = {}) {
  const { googletag } = window;
  const slots = getAllSlots(config);

  googletag.cmd.push(() => {
    slots.forEach((slot) => {
      googletag.defineSlot(
        slot.path,
        [slot.width, slot.height],
        slot.id,
      ).addService(googletag.pubads());
    });

    googletag.setConfig({ singleRequest: true });
    googletag.enableServices();
  });
}

export default createDoubleClick;
